<div
    [formGroup]="childGroup"
    class="material-builder-container"
    fxLayout="column"
    (keydown.enter)="$event.preventDefault()"
>
    <div fxLayout="row wrap" fxFlex="1 1 100%" fxLayoutAlign="start start">
        <ng-container *ngIf="showCoverImg">
            <div *ngIf="selected?.media_id" fxFlex="0 1 100%">
                <app-image-view
                    class="course-img-view"
                    [ignoreThumbnail]="true"
                    [media_id]="selected?.media_id"
                    [showImgModalOnClick]="true"
                    [proportional]="false"
                >
                    <button
                        class="remove-image"
                        mat-icon-button
                        color="warn"
                        type="button"
                        matTooltip="Remove image"
                        i18n-matTooltip
                        (click)="removeImage()"
                    >
                        <mat-icon class="md-18">delete_outline</mat-icon>
                    </button>
                </app-image-view>
            </div>
        </ng-container>

        <mat-form-field class="title-input-material" fxFlex="0 1 100%">
            <textarea
                #title
                matInput
                minRows="1"
                cdkTextareaAutosize
                #autosize="cdkTextareaAutosize"
                cdkAutosizeMinRows="1"
                cdkAutosizeMaxRows="10"
                placeholder="Title"
                i18n-placeholder="@@title"
                formControlName="title"
            ></textarea>

            <button
                *ngIf="selected"
                mat-icon-button
                type="button"
                (click)="updateItemFromResource(selected, 'title')"
                i18n-matTooltip
                matTooltip="Update title from original resource"
                class="update-title-btn add-media-btn"
                [ngClass]="{
                    grey: selected?.title === childGroup.value.title,
                    orange: selected?.title !== childGroup.value.title
                }"
            >
                <mat-icon>update</mat-icon>
            </button>
            <button
                *ngIf="!(loadingUploader | async)"
                mat-icon-button
                type="button"
                (click)="addMedia()"
                i18n-matTooltip
                matTooltip="Add cover image"
                class="add-media-btn"
                [ngClass]="{ green: selected?.media_id }"
            >
                <mat-icon>add_photo_alternate</mat-icon>
            </button>
            <app-kd-logo-loading *ngIf="loadingUploader | async" size="small"></app-kd-logo-loading>
        </mat-form-field>

        <mat-form-field class="can-update-control" fxFlex="0 1 100%">
            <textarea
                #summary
                matInput
                minRows="2"
                cdkTextareaAutosize
                #autosize="cdkTextareaAutosize"
                cdkAutosizeMinRows="1"
                cdkAutosizeMaxRows="10"
                placeholder="Summary"
                i18n-placeholder="@@summary"
                formControlName="bullets"
            ></textarea>
            <ng-container *ngIf="selected">
                <mat-icon
                    matTooltip="Update summary from original resource"
                    i18n-matTooltip
                    matSuffix
                    class="update-description-btn"
                    [ngClass]="{
                        grey: selected?.bullets === childGroup.value.bullets,
                        orange: selected?.bullets !== childGroup.value.bullets
                    }"
                    (click)="$event.stopPropagation(); updateItemFromResource(selected, 'bullets')"
                >
                    update
                </mat-icon>
            </ng-container>
        </mat-form-field>
    </div>
    <ng-container *ngIf="resourceItems?.length">
        <div class="main-material-builder-tabs relative">
            <ng-container
                *ngIf="
                    resourceItems[currentIndex]?.item_type_value === 'item_container' &&
                    resourceItems[currentIndex].children_ids?.length > 1
                "
            >
                <button
                    *ngIf="!(loadingSaveBundle | async)"
                    (click)="$event.stopPropagation(); openItemOrganizer(resourceItems[currentIndex])"
                    class="split-btn"
                    mat-icon-button
                    matTooltip="Manage how material block is taken"
                    i18n-matTooltip="@@manageHowMaterialBlockIsTaken"
                >
                    <mat-icon>vertical_split</mat-icon>
                </button>
                <app-kd-logo-loading *ngIf="loadingSaveBundle | async" size="small"></app-kd-logo-loading>
            </ng-container>
            <mat-tab-group #tabGroup class="builder-materials-items-tabs">
                <mat-tab label="Content" i18n-label="@@content">
                    <div fxLayout="column" fxLayoutAlign="start start" class="">
                        <mat-accordion [multi]="true" fxLayout="column" class="res-items-accordion">
                            <mat-expansion-panel
                                #expansionPanel
                                [expanded]="false"
                                *ngFor="let item of resourceItems; let i = index"
                            >
                                <mat-expansion-panel-header class="main">
                                    <mat-panel-title fxLayout="row" fxLayoutAlign="start center">
                                        <div fxLayoutAlign="start center" fxLayoutGap="10px">
                                            <div class="res-item-index">{{ i + 1 }}</div>
                                            <div class="res-item-title" fxLayout="column" fxLayoutAlign="center start">
                                                <div
                                                    class="top"
                                                    fxLayout="row"
                                                    fxLayoutAlign="start center"
                                                    fxLayoutGap="4px"
                                                >
                                                    <mat-icon>{{
                                                        Utils.getMaterialTypeIcon(item.item_type_value)
                                                    }}</mat-icon>
                                                    <span>{{
                                                        Utils.getMaterialTypeIconLabel(item.item_type_value)
                                                    }}</span>
                                                    <span *ngIf="!!item.children_ids?.length"
                                                        >({{ item.children_ids?.length }})</span
                                                    >
                                                </div>
                                                <span class="bottom">{{ item.title }}</span>
                                            </div>
                                        </div>
                                    </mat-panel-title>
                                    <div *ngIf="expansionPanel.expanded" class="mr-1">
                                        <button
                                            mat-icon-button
                                            matTooltip="Edit"
                                            i18n-matTooltip="@@edit"
                                            (click)="$event.stopPropagation(); onEdit(i)"
                                        >
                                            <mat-icon>edit</mat-icon>
                                        </button>
                                    </div>
                                </mat-expansion-panel-header>
                                <ng-template matExpansionPanelContent>
                                    <app-resource-builder-material-extra
                                        class="mt-1"
                                        [resourceItem]="item"
                                    ></app-resource-builder-material-extra>
                                </ng-template>
                            </mat-expansion-panel>
                        </mat-accordion>
                    </div>
                </mat-tab>
                <mat-tab label="View" i18n-label="@@view">
                    <div class="content-tab-wrapper">
                        <div class="material-form-tabs-wrapper">
                            <mat-tab-group
                                *ngIf="!!childGroup.value.child_resource_items_count"
                                #tabGroup
                                class="builder-materials-items-tabs"
                                (selectedTabChange)="
                                    currentIndex = $event.index;
                                    displayedMaterialResourceItem$.next(resourceItems[currentIndex])
                                "
                            >
                                <mat-tab *ngFor="let item of resourceItems; let i = index">
                                    <ng-template mat-tab-label>
                                        <div class="tab-label-container" [matTooltip]="item.title">
                                            <mat-icon
                                                *ngIf="item.item_type_value !== 'item_container'"
                                                class="dark-blue-color"
                                                >{{ Utils.getMaterialTypeIcon(item.item_type_value) }}</mat-icon
                                            >

                                            <div
                                                class="item-container-label"
                                                *ngIf="item.item_type_value === 'item_container'"
                                            >
                                                <mat-icon class="dark-blue-color">account_tree</mat-icon>
                                                <span *ngIf="!!item.children_ids?.length"
                                                    >({{ item.children_ids?.length }})</span
                                                >
                                            </div>

                                            <div class="item-index">
                                                <span>{{ i + 1 }}</span>
                                            </div>
                                        </div>
                                    </ng-template>
                                </mat-tab>
                            </mat-tab-group>
                        </div>
                        <div class="material-item-title">{{ resourceItems[currentIndex].title }}</div>
                        <app-resource-builder-material-extra
                            class="mt-1"
                            [resourceItemSubject]="displayedMaterialResourceItem$"
                        ></app-resource-builder-material-extra>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </div>
    </ng-container>
</div>
